import React from 'react';

const Testimony = () => {
  return (
    <div>
      
    </div>
  );
}

export default Testimony;
